module.exports = __webpack_public_path__ + "static/img/rrrr_28.f735fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_28.png
// module id = xalD
// module chunks = 1